<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>确定出库</span>
            <div>
              <el-button type="primary" size="small" @click="_goBack">
                <i class="el-icon-close"></i>&nbsp;返回
              </el-button>
            </div>
          </div>
          <div>
            <el-row>
              <el-col :span="6">
                <div class="form-group">
                  <label class="col-form-label">工单编码：</label>
                  <label>{{ upShopHouseDetailInfo.orderId }}</label>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="form-group">
                  <label class="col-form-label">申请人:</label>
                  <label>{{ upShopHouseDetailInfo.personName }}</label>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="form-group">
                  <label class="col-form-label">申请时间:</label>
                  <label>{{ upShopHouseDetailInfo.createTime }}</label>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="form-group">
                  <label class="col-form-label">订单状态:</label>
                  <label>{{ upShopHouseDetailInfo.stateName }}</label>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <div class="form-group">
                  <label class="col-form-label">备注:</label>
                  <label>{{ upShopHouseDetailInfo.remark }}</label>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-row class="margin-top">
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>商品信息</span>
          </div>
          <el-table :data="upShopHouseDetailInfo.inoutOrderProducts" stripe style="width: 100%">
            <el-table-column prop="index" label="序号" width="100" align="center">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column prop="prodName" label="商品名称" align="center"></el-table-column>
            <el-table-column prop="productId" label="商品编号" align="center"></el-table-column>
            <el-table-column prop="specName" label="规格" align="center"></el-table-column>
            <el-table-column prop="prodCount" label="申请单数量" align="center"></el-table-column>
            <el-table-column label="实际出库数量" align="center">
              <template slot-scope="scope">
                <el-input v-model="scope.row.actCount" type="number"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="price" label="价格" align="center"></el-table-column>
            <el-table-column prop="amount" label="金额" align="center"></el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button-group v-if="scope.row.state == '5005'">
                  <el-button size="mini" @click="_doCancelProduct(scope.row)">取消出库</el-button>
                </el-button-group>
                <el-button-group v-if="scope.row.state == '4004'">
                  <el-button size="mini" disabled>已取消</el-button>
                </el-button-group>
              </template>
            </el-table-column>
          </el-table>

          <div v-if="upShopHouseDetailInfo.state == '5005'" style="margin-top: 20px;">
            <el-button type="primary" style="float: right;" @click="doInoutOrder">
              <i class="el-icon-check"></i>&nbsp;确定出库
            </el-button>
            <el-button type="warning" style="float: right; margin-right: 20px;" @click="_doCancelOrder">
              <i class="el-icon-close"></i>&nbsp;取消出库单
            </el-button>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { queryInoutOrder, queryInoutOrderProduct, saveOrderOut, updateInoutOrder, updateInoutOrderProduct } from '@/api/goods/doOrderDetailOutApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  data() {
    return {
      upShopHouseDetailInfo: {
        orderId: '',
        stateName: '',
        state: '',
        personName: '',
        createTime: '',
        personId: '',
        remark: '',
        orderType: '',
        shopId: '',
        inoutOrderProducts: []
      }
    }
  },
  created() {
    this.upShopHouseDetailInfo.shopId = getShopId()
    const orderId = this.$route.query.orderId
    if (!orderId) {
      this.$message.error('非法操作')
      this.$router.go(-1)
      return
    }
    this.upShopHouseDetailInfo.orderId = orderId
    this._listOrder()
    this._listInoutOrderProduct()
  },
  methods: {
    async _listOrder() {
      try {
        const res = await queryInoutOrder({
          page: 1,
          row: 1,
          orderId: this.upShopHouseDetailInfo.orderId
        })
        if (res.data && res.data.length > 0) {
          Object.assign(this.upShopHouseDetailInfo, res.data[0])
        } else {
          console.warn('未找到订单详情')
          this.$message.warning('未找到订单详情')
        }
      } catch (error) {
        console.error('请求订单详情失败:', error)
        this.$message.error('加载订单详情失败')
      }
    },
    async _listInoutOrderProduct() {
      try {
        const res = await queryInoutOrderProduct({
          page: 1,
          row: 50,
          orderId: this.upShopHouseDetailInfo.orderId,
          shopId: this.upShopHouseDetailInfo.shopId
        })
        this.upShopHouseDetailInfo.inoutOrderProducts = res.data || []
        this.upShopHouseDetailInfo.inoutOrderProducts.forEach(item => {
          item.actCount = item.prodCount
        })
      } catch (error) {
        console.error('请求商品列表失败:', error)
        this.$message.error('加载商品信息失败')
      }
    },
    async doInoutOrder() {
      try {
        const res = await saveOrderOut(this.upShopHouseDetailInfo)
        if (res.code === 0) {
          this.$message.success("出库成功")
          this._goBack()
        } else {
          this.$message.error(res.msg || "出库失败")
        }
      } catch (error) {
        console.error('出库失败:', error)
        this.$message.error(error.message || error || "出库失败")
      }
    },
    async _doCancelOrder() {
      this.upShopHouseDetailInfo.state = "6006"
      try {
        const res = await updateInoutOrder(this.upShopHouseDetailInfo)
        if (res.code === 0) {
          const _cancelProduct = {
            orderId: this.upShopHouseDetailInfo.orderId,
            statusCd: "0",
            state: "6006"
          }
          this.upShopHouseDetailInfo.inoutOrderProducts.forEach(item => {
            item.state = "6006"
          })
          this.upShopHouseDetailInfo.stateName = "出库失败"
          this._doCancelProduct(_cancelProduct)
          this.$message.success(res.msg || "取消成功")
        } else {
          this.$message.error(res.msg || "取消失败")
        }
      } catch (error) {
        console.error('取消出库单失败:', error)
        this.$message.error(error.message || error || "取消出库单失败")
      }
    },
    async _doCancelProduct(_inoutProduct) {
      _inoutProduct.state = "6006"
      try {
        const res = await updateInoutOrderProduct(_inoutProduct)
        if (res.code === 0) {
          this.$message.success(res.msg || "取消商品出库成功")
        } else {
          this.$message.error(res.msg || "取消商品出库失败")
        }
      } catch (error) {
        console.error('取消商品出库失败:', error)
        this.$message.error(error.message || error || "取消商品出库失败")
      }
    },
    _goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.form-group {
  margin-bottom: 15px;
}

.col-form-label {
  font-weight: bold;
  margin-right: 10px;
}
</style>